export const SUB_MERCHANT_COUNTRY_CODE = [
  {
    id: 702,
    name: 'Singapore'
  },
  {
    id: 764,
    name: 'Thailand'
  },
  {
    id: 458,
    name: 'Malaysia'
  },
  {
    id: 360,
    name: 'Indonesia'
  },
  {
    id: 840,
    name: 'United States'
  }
]

export const STATUS = [
  {
    id: true,
    name: 'Yes'
  },
  {
    id: false,
    name: 'No'
  }
]

export const rowsPerPageOptions = [25, 50, 100]
export const rowsPerPage = 50
export const pageNumber = 1

export const prefixV3 = "/3/app"

export const EXCHANGE_RATE_CURRENCIES = [
  "AUD",
  "CHF",
  "EUR",
  "GBP",
  "HKD",
  "IDR",
  "JPY",
  "MYR",
  "PHP",
  "THB",
  "USD",
];

export const HARDCODED_FROM_CURRENCY = 'SGD';

export const EXCHANGE_RATE_YEAR_THRESHOLD = 2025;

export const INCOMING_PENDING_FILTER_START_DATE = '2026-03-01';

export const NO_PAYOUT_DATE_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const SCOPE_IDENTIFIERS = {
  ACCOUNT: "admin_user",
  GROUP: "admin_role",
  MERCHANT_USER: "merchant_user",
  BUSINESS_ENTITY: "business_entity",
  BANK_ACCOUNT: "bank_account",
  MERCHANT: "merchant",
  TERMINAL: "terminal",
  DEPARTMENT: "department",
  OXYGEN7_ENTITY: "oxygen7_entity",
  PAYMENT: "payment",
  MERCHANT_PAYOUT_INFO: "merchant_payout_info",
  TRANSACTION: "transactions",
  RECON_SETTLEMENT: "reconsettlement",
  REPORT: "report",
  ADJUSTMENT: "adjustment",
  SECURITY_DEPOSIT: "security_deposit",
  PAYOUT_UPLOAD_FILE: "payout_upload_file",
  PAYOUT_VIEW_DATA: "payout_view_data",
  ACQUIRER_FILE: "acquirer_file",
  PAYNOW_DESCRIPTOR: "paynow_descriptor",
  MPI: "mpi",
  NO_PAYOUT_DAY: "no_payout_day",
  PAYMENT_HOST: "payment_host",
  PAYMENT_BRAND: "payment_brand",
  PAYMENT_METHOD: "payment_method",
  NOTIFICATIONS: "notifications",
  AUDIT_LOGS: "audit_logs",
  QUICK_PAYMENT: "quick_payment",
  ONBOARDING: "onboarding",
  EXCHANGE_RATE: "exchange_rate",
  BANK_STATEMENT: "bank_statement",
  PAYNOW_DUPLICATE: "paynow_duplicate",
  EXCEPTION_HANDLING: "exception_handling",
}

export const ROLES = {
  VIEW: "View",
  ADD: "Add",
  UPLOAD_FILE: "Upload file",
}

export const SERVICE_SCOPE = ["Admin portal", "Merchant portal"];

export const acquirerList = [
  { id: "alipay", name: "Alipay" },
  { id: "allinpay", name: "Allinpay" },
  { id: "atome", name: "Atome" },
  { id: "dash", name: "Dash" },
  { id: "dci", name: "DCI" },
  { id: "dcs", name: "DCS" },
  { id: "fiuu", name: "Fiuu" },
  { id: "fomopay", name: "FOMOPay" },
  { id: "gp", name: "GP" },
  { id: "grabpay", name: "GrabPay" },
  { id: "liquidnet", name: "Liquid" },
  { id: "paynow", name: "PayNow - SCB" },
  { id: "shopee", name: "ShopeePay" },
  { id: "wechat", name: "WeChat" },
  
];

export const MPI_TYPE = {
  0: "No MPI",
  1: "Acquirer's MPI",
  2: "Oxygen7 MPI (HiTrust)",
};
 
export const MPI_TYPE_LIST = Object.entries(MPI_TYPE).map(([id, name]) => ({id, name}));
export const noCentsCurrencies = ["JPY", "KRW", "THB"]

export const validCurrencies = [
  'AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN',
  'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BRL',
  'BSD', 'BTN', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHF', 'CLP', 'CNY',
  'COP', 'CRC', 'CUP', 'CVK', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EGP',
  'ERN', 'ETB', 'EUR', 'FJD', 'FKP', 'FOK', 'GBP', 'GEL', 'GHS', 'GIP',
  'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL', 'HRK', 'HTG', 'HUF', 'IDR',
  'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD', 'JPY', 'KES', 'KGS',
  'KHR', 'KID', 'KMF', 'KRW', 'KWD', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR',
  'LRD', 'LSL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MNT', 'MOP',
  'MRU', 'MUR', 'MVR', 'MWK', 'MXN', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO',
  'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN',
  'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SDG',
  'SEK', 'SGD', 'SHP', 'SLL', 'SOS', 'SRD', 'SSP', 'STN', 'SYP', 'SZL',
  'THB', 'TJS', 'TMT', 'TND', 'TOP', 'TRY', 'TTD', 'TVD', 'TWD', 'TZS',
  'UAH', 'UGX', 'USD', 'UYU', 'UZS', 'VES', 'VND', 'VUV', 'WST', 'XAF',
  'XAG', 'XAU', 'XCD', 'XDR', 'XOF', 'XPF', 'YER', 'ZAR', 'ZMW', 'ZWL'
];

export function convertAmountByCurrency(currency, amount) {
  switch (currency) {
    case "USD":
    case "SGD":
    case "MYR":
    case "THB":
      return Number((amount * 100).toFixed(0));
    default:
      return Number(amount);
  }
}

export const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/;

export const INTERNATIONAL_COUNTRY_LIST = [
  { id: 702, name: 'SINGAPORE' },
  { id: 458, name: 'MALAYSIA' },
  { id: 764, name: 'THAILAND' },
  { id: 4, name: 'AFGHANISTAN' },
  { id: 248, name: 'ÅLAND ISLANDS' },
  { id: 8, name: 'ALBANIA' },
  { id: 12, name: 'ALGERIA' },
  { id: 16, name: 'AMERICAN SAMOA' },
  { id: 20, name: 'ANDORRA' },
  { id: 24, name: 'ANGOLA' },
  { id: 660, name: 'ANGUILLA' },
  { id: 10, name: 'ANTARCTICA' },
  { id: 28, name: 'ANTIGUA AND BARBUDA' },
  { id: 32, name: 'ARGENTINA' },
  { id: 51, name: 'ARMENIA' },
  { id: 533, name: 'ARUBA' },
  { id: '036', name: 'AUSTRALIA' },
  { id: 40, name: 'AUSTRIA' },
  { id: 31, name: 'AZERBAIJAN' },
  { id: 44, name: 'BAHAMAS' },
  { id: 48, name: 'BAHRAIN' },
  { id: 50, name: 'BANGLADESH' },
  { id: 52, name: 'BARBADOS' },
  { id: 112, name: 'BELARUS' },
  { id: 56, name: 'BELGIUM' },
  { id: 84, name: 'BELIZE' },
  { id: 204, name: 'BENIN' },
  { id: 60, name: 'BERMUDA' },
  { id: 64, name: 'BHUTAN' },
  { id: 68, name: 'BOLIVIA' },
  { id: 535, name: 'BONAIRE, SINT EUSTATIUS AND SABA' },
  { id: 70, name: 'BOSNIA AND HERZEGOVINA' },
  { id: 72, name: 'BOTSWANA' },
  { id: 74, name: 'BOUVET ISLAND' },
  { id: 76, name: 'BRAZIL' },
  { id: 86, name: 'BRITISH INDIAN OCEAN TERRITORY' },
  { id: 96, name: 'BRUNEI DARUSSALAM' },
  { id: 100, name: 'BULGARIA' },
  { id: 854, name: 'BURKINA FASO' },
  { id: 108, name: 'BURUNDI' },
  { id: 132, name: 'CABO VERDE' },
  { id: 116, name: 'CAMBODIA' },
  { id: 120, name: 'CAMEROON' },
  { id: 124, name: 'CANADA' },
  { id: 136, name: 'CAYMAN ISLANDS' },
  { id: 140, name: 'CENTRAL AFRICAN REPUBLIC' },
  { id: 148, name: 'CHAD' },
  { id: 152, name: 'CHILE' },
  { id: 156, name: 'CHINA' },
  { id: 162, name: 'CHRISTMAS ISLAND' },
  { id: 166, name: 'COCOS (KEELING) ISLANDS' },
  { id: 170, name: 'COLOMBIA' },
  { id: 174, name: 'COMOROS' },
  { id: 178, name: 'CONGO' },
  { id: 180, name: 'CONGO, DEMOCRATIC REPUBLIC OF THE' },
  { id: 184, name: 'COOK ISLANDS' },
  { id: 188, name: 'COSTA RICA' },
  { id: 191, name: 'CROATIA' },
  { id: 192, name: 'CUBA' },
  { id: 531, name: 'CURAÇAO' },
  { id: 196, name: 'CYPRUS' },
  { id: 203, name: 'CZECHIA' },
  { id: 384, name: "CÔTE D'IVOIRE" },
  { id: 208, name: 'DENMARK' },
  { id: 262, name: 'DJIBOUTI' },
  { id: 212, name: 'DOMINICA' },
  { id: 214, name: 'DOMINICAN REPUBLIC' },
  { id: 218, name: 'ECUADOR' },
  { id: 818, name: 'EGYPT' },
  { id: 222, name: 'EL SALVADOR' },
  { id: 226, name: 'EQUATORIAL GUINEA' },
  { id: 232, name: 'ERITREA' },
  { id: 233, name: 'ESTONIA' },
  { id: 748, name: 'ESWATINI' },
  { id: 231, name: 'ETHIOPIA' },
  { id: 238, name: 'FALKLAND ISLANDS' },
  { id: 234, name: 'FAROE ISLANDS' },
  { id: 242, name: 'FIJI' },
  { id: 246, name: 'FINLAND' },
  { id: 250, name: 'FRANCE' },
  { id: 254, name: 'FRENCH GUIANA' },
  { id: 258, name: 'FRENCH POLYNESIA' },
  { id: 260, name: 'FRENCH SOUTHERN TERRITORIES' },
  { id: 266, name: 'GABON' },
  { id: 270, name: 'GAMBIA' },
  { id: 268, name: 'GEORGIA' },
  { id: 276, name: 'GERMANY' },
  { id: 288, name: 'GHANA' },
  { id: 292, name: 'GIBRALTAR' },
  { id: 300, name: 'GREECE' },
  { id: 304, name: 'GREENLAND' },
  { id: 308, name: 'GRENADA' },
  { id: 312, name: 'GUADELOUPE' },
  { id: 316, name: 'GUAM' },
  { id: 320, name: 'GUATEMALA' },
  { id: 831, name: 'GUERNSEY' },
  { id: 324, name: 'GUINEA' },
  { id: 624, name: 'GUINEA-BISSAU' },
  { id: 328, name: 'GUYANA' },
  { id: 332, name: 'HAITI' },
  { id: 334, name: 'HEARD ISLAND AND MCDONALD ISLANDS' },
  { id: 336, name: 'HOLY SEE' },
  { id: 340, name: 'HONDURAS' },
  { id: 344, name: 'HONG KONG' },
  { id: 348, name: 'HUNGARY' },
  { id: 352, name: 'ICELAND' },
  { id: 356, name: 'INDIA' },
  { id: 360, name: 'INDONESIA' },
  { id: 364, name: 'IRAN' },
  { id: 368, name: 'IRAQ' },
  { id: 372, name: 'IRELAND' },
  { id: 833, name: 'ISLE OF MAN' },
  { id: 376, name: 'ISRAEL' },
  { id: 380, name: 'ITALY' },
  { id: 388, name: 'JAMAICA' },
  { id: 392, name: 'JAPAN' },
  { id: 832, name: 'JERSEY' },
  { id: 400, name: 'JORDAN' },
  { id: 398, name: 'KAZAKHSTAN' },
  { id: 404, name: 'KENYA' },
  { id: 296, name: 'KIRIBATI' },
  { id: 408, name: 'KOREA, DEMOCRATIC PEOPLE\'S REPUBLIC OF' },
  { id: 410, name: 'KOREA, REPUBLIC OF' },
  { id: 414, name: 'KUWAIT' },
  { id: 417, name: 'KYRGYZSTAN' },
  { id: 418, name: 'LAO PEOPLE\'S DEMOCRATIC REPUBLIC' },
  { id: 428, name: 'LATVIA' },
  { id: 422, name: 'LEBANON' },
  { id: 426, name: 'LESOTHO' },
  { id: 430, name: 'LIBERIA' },
  { id: 434, name: 'LIBYA' },
  { id: 438, name: 'LIECHTENSTEIN' },
  { id: 440, name: 'LITHUANIA' },
  { id: 442, name: 'LUXEMBOURG' },
  { id: 446, name: 'MACAO' },
  { id: 450, name: 'MADAGASCAR' },
  { id: 454, name: 'MALAWI' },
  { id: 462, name: 'MALDIVES' },
  { id: 466, name: 'MALI' },
  { id: 470, name: 'MALTA' },
  { id: 584, name: 'MARSHALL ISLANDS' },
  { id: 474, name: 'MARTINIQUE' },
  { id: 478, name: 'MAURITANIA' },
  { id: 480, name: 'MAURITIUS' },
  { id: 175, name: 'MAYOTTE' },
  { id: 484, name: 'MEXICO' },
  { id: 583, name: 'MICRONESIA' },
  { id: 498, name: 'MOLDOVA' },
  { id: 492, name: 'MONACO' },
  { id: 496, name: 'MONGOLIA' },
  { id: 499, name: 'MONTENEGRO' },
  { id: 500, name: 'MONTSERRAT' },
  { id: 504, name: 'MOROCCO' },
  { id: 508, name: 'MOZAMBIQUE' },
  { id: 104, name: 'MYANMAR' },
  { id: 516, name: 'NAMIBIA' },
  { id: 520, name: 'NAURU' },
  { id: 524, name: 'NEPAL' },
  { id: 528, name: 'NETHERLANDS' },
  { id: 540, name: 'NEW CALEDONIA' },
  { id: 554, name: 'NEW ZEALAND' },
  { id: 558, name: 'NICARAGUA' },
  { id: 562, name: 'NIGER' },
  { id: 566, name: 'NIGERIA' },
  { id: 570, name: 'NIUE' },
  { id: 574, name: 'NORFOLK ISLAND' },
  { id: 807, name: 'NORTH MACEDONIA' },
  { id: 580, name: 'NORTHERN MARIANA ISLANDS' },
  { id: 578, name: 'NORWAY' },
  { id: 512, name: 'OMAN' },
  { id: 586, name: 'PAKISTAN' },
  { id: 585, name: 'PALAU' },
  { id: 275, name: 'PALESTINE, STATE OF' },
  { id: 591, name: 'PANAMA' },
  { id: 598, name: 'PAPUA NEW GUINEA' },
  { id: 600, name: 'PARAGUAY' },
  { id: 604, name: 'PERU' },
  { id: 608, name: 'PHILIPPINES' },
  { id: 612, name: 'PITCAIRN' },
  { id: 616, name: 'POLAND' },
  { id: 620, name: 'PORTUGAL' },
  { id: 630, name: 'PUERTO RICO' },
  { id: 634, name: 'QATAR' },
  { id: 638, name: 'RÉUNION' },
  { id: 642, name: 'ROMANIA' },
  { id: 643, name: 'RUSSIAN FEDERATION' },
  { id: 646, name: 'RWANDA' },
  { id: 652, name: 'SAINT BARTHÉLEMY' },
  { id: 654, name: 'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA' },
  { id: 659, name: 'SAINT KITTS AND NEVIS' },
  { id: 662, name: 'SAINT LUCIA' },
  { id: 663, name: 'SAINT MARTIN (FRENCH PART)' },
  { id: 666, name: 'SAINT PIERRE AND MIQUELON' },
  { id: 670, name: 'SAINT VINCENT AND THE GRENADINES' },
  { id: 882, name: 'SAMOA' },
  { id: 674, name: 'SAN MARINO' },
  { id: 678, name: 'SAO TOME AND PRINCIPE' },
  { id: 682, name: 'SAUDI ARABIA' },
  { id: 686, name: 'SENEGAL' },
  { id: 688, name: 'SERBIA' },
  { id: 690, name: 'SEYCHELLES' },
  { id: 694, name: 'SIERRA LEONE' },
  { id: 534, name: 'SINT MAARTEN (DUTCH PART)' },
  { id: 703, name: 'SLOVAKIA' },
  { id: 705, name: 'SLOVENIA' },
  { id: 90, name: 'SOLOMON ISLANDS' },
  { id: 706, name: 'SOMALIA' },
  { id: 710, name: 'SOUTH AFRICA' },
  { id: 239, name: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS' },
  { id: 728, name: 'SOUTH SUDAN' },
  { id: 724, name: 'SPAIN' },
  { id: 144, name: 'SRI LANKA' },
  { id: 729, name: 'SUDAN' },
  { id: 740, name: 'SURINAME' },
  { id: 744, name: 'SVALBARD AND JAN MAYEN' },
  { id: 752, name: 'SWEDEN' },
  { id: 756, name: 'SWITZERLAND' },
  { id: 760, name: 'SYRIAN ARAB REPUBLIC' },
  { id: 158, name: 'TAIWAN' },
  { id: 762, name: 'TAJIKISTAN' },
  { id: 834, name: 'TANZANIA, UNITED REPUBLIC OF' },
  { id: 626, name: 'TIMOR-LESTE' },
  { id: 768, name: 'TOGO' },
  { id: 772, name: 'TOKELAU' },
  { id: 776, name: 'TONGA' },
  { id: 780, name: 'TRINIDAD AND TOBAGO' },
  { id: 788, name: 'TUNISIA' },
  { id: 792, name: 'TURKEY' },
  { id: 795, name: 'TURKMENISTAN' },
  { id: 796, name: 'TURKS AND CAICOS ISLANDS' },
  { id: 798, name: 'TUVALU' },
  { id: 800, name: 'UGANDA' },
  { id: 804, name: 'UKRAINE' },
  { id: 784, name: 'UNITED ARAB EMIRATES' },
  { id: 826, name: 'UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND' },
  { id: 840, name: 'UNITED STATES OF AMERICA' },
  { id: 581, name: 'UNITED STATES MINOR OUTLYING ISLANDS' },
  { id: 858, name: 'URUGUAY' },
  { id: 860, name: 'UZBEKISTAN' },
  { id: 548, name: 'VANUATU' },
  { id: 862, name: 'VENEZUELA' },
  { id: 704, name: 'VIET NAM' },
  { id: 92, name: 'VIRGIN ISLANDS, BRITISH' },
  { id: 850, name: 'VIRGIN ISLANDS, U.S.' },
  { id: 876, name: 'WALLIS AND FUTUNA' },
  { id: 732, name: 'WESTERN SAHARA' },
  { id: 887, name: 'YEMEN' },
  { id: 894, name: 'ZAMBIA' },
  { id: 716, name: 'ZIMBABWE' }
]

export const MAPPED_REGISTERED_COUNTRY = {
  SGP: 'SINGAPORE',
  MYS: 'MALAYSIA',
  THA: 'THAILAND',
  AFG: 'AFGHANISTAN',
  ALA: 'ÅLAND ISLANDS',
  ALB: 'ALBANIA',
  DZA: 'ALGERIA',
  ASM: 'AMERICAN SAMOA',
  AND: 'ANDORRA',
  AGO: 'ANGOLA',
  AIA: 'ANGUILLA',
  ATA: 'ANTARCTICA',
  ATG: 'ANTIGUA AND BARBUDA',
  ARG: 'ARGENTINA',
  ARM: 'ARMENIA',
  ABW: 'ARUBA',
  AUS: 'AUSTRALIA',
  AUT: 'AUSTRIA',
  AZE: 'AZERBAIJAN',
  BHS: 'BAHAMAS',
  BHR: 'BAHRAIN',
  BGD: 'BANGLADESH',
  BRB: 'BARBADOS',
  BLR: 'BELARUS',
  BEL: 'BELGIUM',
  BLZ: 'BELIZE',
  BEN: 'BENIN',
  BMU: 'BERMUDA',
  BTN: 'BHUTAN',
  BOL: 'BOLIVIA',
  BES: 'BONAIRE, SINT EUSTATIUS AND SABA',
  BIH: 'BOSNIA AND HERZEGOVINA',
  BWA: 'BOTSWANA',
  BVT: 'BOUVET ISLAND',
  BRA: 'BRAZIL',
  IOT: 'BRITISH INDIAN OCEAN TERRITORY',
  BRN: 'BRUNEI DARUSSALAM',
  BGR: 'BULGARIA',
  BFA: 'BURKINA FASO',
  BDI: 'BURUNDI',
  CPV: 'CABO VERDE',
  KHM: 'CAMBODIA',
  CMR: 'CAMEROON',
  CAN: 'CANADA',
  CYM: 'CAYMAN ISLANDS',
  CAF: 'CENTRAL AFRICAN REPUBLIC',
  TCD: 'CHAD',
  CHL: 'CHILE',
  CHN: 'CHINA',
  CXR: 'CHRISTMAS ISLAND',
  CCK: 'COCOS (KEELING) ISLANDS',
  COL: 'COLOMBIA',
  COM: 'COMOROS',
  COG: 'CONGO',
  COD: 'CONGO, DEMOCRATIC REPUBLIC OF THE',
  COK: 'COOK ISLANDS',
  CRI: 'COSTA RICA',
  HRV: 'CROATIA',
  CUB: 'CUBA',
  CUW: 'CURAÇAO',
  CYP: 'CYPRUS',
  CZE: 'CZECHIA',
  CIV: "CÔTE D'IVOIRE",
  DNK: 'DENMARK',
  DJI: 'DJIBOUTI',
  DMA: 'DOMINICA',
  DOM: 'DOMINICAN REPUBLIC',
  ECU: 'ECUADOR',
  EGY: 'EGYPT',
  SLV: 'EL SALVADOR',
  GNQ: 'EQUATORIAL GUINEA',
  ERI: 'ERITREA',
  EST: 'ESTONIA',
  SWZ: 'ESWATINI',
  ETH: 'ETHIOPIA',
  FLK: 'FALKLAND ISLANDS',
  FRO: 'FAROE ISLANDS',
  FJI: 'FIJI',
  FIN: 'FINLAND',
  FRA: 'FRANCE',
  GUF: 'FRENCH GUIANA',
  PYF: 'FRENCH POLYNESIA',
  ATF: 'FRENCH SOUTHERN TERRITORIES',
  GAB: 'GABON',
  GMB: 'GAMBIA',
  GEO: 'GEORGIA',
  DEU: 'GERMANY',
  GHA: 'GHANA',
  GIB: 'GIBRALTAR',
  GRC: 'GREECE',
  GRL: 'GREENLAND',
  GRD: 'GRENADA',
  GLP: 'GUADELOUPE',
  GUM: 'GUAM',
  GTM: 'GUATEMALA',
  GGY: 'GUERNSEY',
  GIN: 'GUINEA',
  GNB: 'GUINEA-BISSAU',
  GUY: 'GUYANA',
  HTI: 'HAITI',
  HMD: 'HEARD ISLAND AND MCDONALD ISLANDS',
  VAT: 'HOLY SEE',
  HND: 'HONDURAS',
  HKG: 'HONG KONG',
  HUN: 'HUNGARY',
  ISL: 'ICELAND',
  IND: 'INDIA',
  IDN: 'INDONESIA',
  IRN: 'IRAN',
  IRQ: 'IRAQ',
  IRL: 'IRELAND',
  IMN: 'ISLE OF MAN',
  ISR: 'ISRAEL',
  ITA: 'ITALY',
  JAM: 'JAMAICA',
  JPN: 'JAPAN',
  JEY: 'JERSEY',
  JOR: 'JORDAN',
  KAZ: 'KAZAKHSTAN',
  KEN: 'KENYA',
  KIR: 'KIRIBATI',
  PRK: "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF",
  KOR: 'KOREA, REPUBLIC OF',
  KWT: 'KUWAIT',
  KGZ: 'KYRGYZSTAN',
  LAO: "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
  LVA: 'LATVIA',
  LBN: 'LEBANON',
  LSO: 'LESOTHO',
  LBR: 'LIBERIA',
  LBY: 'LIBYA',
  LIE: 'LIECHTENSTEIN',
  LTU: 'LITHUANIA',
  LUX: 'LUXEMBOURG',
  MAC: 'MACAO',
  MDG: 'MADAGASCAR',
  MWI: 'MALAWI',
  MDV: 'MALDIVES',
  MLI: 'MALI',
  MLT: 'MALTA',
  MHL: 'MARSHALL ISLANDS',
  MTQ: 'MARTINIQUE',
  MRT: 'MAURITANIA',
  MUS: 'MAURITIUS',
  MYT: 'MAYOTTE',
  MEX: 'MEXICO',
  FSM: 'MICRONESIA',
  MDA: 'MOLDOVA',
  MCO: 'MONACO',
  MNG: 'MONGOLIA',
  MNE: 'MONTENEGRO',
  MSR: 'MONTSERRAT',
  MAR: 'MOROCCO',
  MOZ: 'MOZAMBIQUE',
  MMR: 'MYANMAR',
  NAM: 'NAMIBIA',
  NRU: 'NAURU',
  NPL: 'NEPAL',
  NLD: 'NETHERLANDS',
  NCL: 'NEW CALEDONIA',
  NZL: 'NEW ZEALAND',
  NIC: 'NICARAGUA',
  NER: 'NIGER',
  NGA: 'NIGERIA',
  NIU: 'NIUE',
  NFK: 'NORFOLK ISLAND',
  MKD: 'NORTH MACEDONIA',
  MNP: 'NORTHERN MARIANA ISLANDS',
  NOR: 'NORWAY',
  OMN: 'OMAN',
  PAK: 'PAKISTAN',
  PLW: 'PALAU',
  PSE: 'PALESTINE, STATE OF',
  PAN: 'PANAMA',
  PNG: 'PAPUA NEW GUINEA',
  PRY: 'PARAGUAY',
  PER: 'PERU',
  PHL: 'PHILIPPINES',
  PCN: 'PITCAIRN',
  POL: 'POLAND',
  PRT: 'PORTUGAL',
  PRI: 'PUERTO RICO',
  QAT: 'QATAR',
  REU: 'RÉUNION',
  ROU: 'ROMANIA',
  RUS: 'RUSSIAN FEDERATION',
  RWA: 'RWANDA',
  BLM: 'SAINT BARTHÉLEMY',
  SHN: 'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA',
  KNA: 'SAINT KITTS AND NEVIS',
  LCA: 'SAINT LUCIA',
  MAF: 'SAINT MARTIN (FRENCH PART)',
  SPM: 'SAINT PIERRE AND MIQUELON',
  VCT: 'SAINT VINCENT AND THE GRENADINES',
  WSM: 'SAMOA',
  SMR: 'SAN MARINO',
  STP: 'SAO TOME AND PRINCIPE',
  SAU: 'SAUDI ARABIA',
  SEN: 'SENEGAL',
  SRB: 'SERBIA',
  SYC: 'SEYCHELLES',
  SLE: 'SIERRA LEONE',
  SXM: 'SINT MAARTEN (DUTCH PART)',
  SVK: 'SLOVAKIA',
  SVN: 'SLOVENIA',
  SLB: 'SOLOMON ISLANDS',
  SOM: 'SOMALIA',
  ZAF: 'SOUTH AFRICA',
  SGS: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
  SSD: 'SOUTH SUDAN',
  ESP: 'SPAIN',
  LKA: 'SRI LANKA',
  SDN: 'SUDAN',
  SUR: 'SURINAME',
  SJM: 'SVALBARD AND JAN MAYEN',
  SWE: 'SWEDEN',
  CHE: 'SWITZERLAND',
  SYR: 'SYRIAN ARAB REPUBLIC',
  TWN: 'TAIWAN',
  TJK: 'TAJIKISTAN',
  TZA: 'TANZANIA, UNITED REPUBLIC OF',
  TLS: 'TIMOR-LESTE',
  TGO: 'TOGO',
  TKL: 'TOKELAU',
  TON: 'TONGA',
  TTO: 'TRINIDAD AND TOBAGO',
  TUN: 'TUNISIA',
  TUR: 'TURKEY',
  TKM: 'TURKMENISTAN',
  TCA: 'TURKS AND CAICOS ISLANDS',
  TUV: 'TUVALU',
  UGA: 'UGANDA',
  UKR: 'UKRAINE',
  ARE: 'UNITED ARAB EMIRATES',
  GBR: 'UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND',
  USA: 'UNITED STATES OF AMERICA',
  UMI: 'UNITED STATES MINOR OUTLYING ISLANDS',
  URY: 'URUGUAY',
  UZB: 'UZBEKISTAN',
  VUT: 'VANUATU',
  VEN: 'VENEZUELA',
  VNM: 'VIET NAM',
  VGB: 'VIRGIN ISLANDS, BRITISH',
  VIR: 'VIRGIN ISLANDS, U.S.',
  WLF: 'WALLIS AND FUTUNA',
  ESH: 'WESTERN SAHARA',
  YEM: 'YEMEN',
  ZMB: 'ZAMBIA',
  ZWE: 'ZIMBABWE'
}

export const RISK_LEVEL = [
  { id: "low", label: "Low" },
  { id: "mid", label: "Mid" },
  { id: "high", label: "High" },
]

// Liquidnet payment host constants
export const LIQUID_PAYEE_PREFIX = process.env.REACT_APP_LIQUID_PAYEE_PREFIX || "4000571";

export const PAYMENT_HOST_LIST = {
  FIUU: 'fiuu',
  FIUU_DIRECT: 'fiuu-direct',
  FIUU_DIRECT_PF: 'fiuu-direct-pf',
  ALLINPAY: 'allinpay',
  MINESEC: 'minesec',
  DCI: 'dci',
  DCS: 'dcs',
  DBS: 'dbs',
  GRABPAY: 'grabpay',
  GRABPAY_GW2: 'grabpay-gw2',
  GRABPAY_SG: 'grabpay-sg',
  GRABPAY_V1: 'grabpay-v1',
  SCB: 'scb',
  SCB_GW2: 'scb-gw2',
  PAYNOW: 'paynow',
  SHOPEEPAY: 'shopeepay',
  SHOPEEPAY_SG: 'shopeepay-sg',
  SHOPEEPAY_TH: 'shopeepay-th',
  SHOPEEPAY_MY: 'shopeepay-my',
  LIQUIDNET: 'liquidnet',
  LINEPAY: 'linepay',
  ALIPAY: 'alipay',
  WECHAT: 'wechat',
  ATOME: 'atome',
  DASH: 'dash',
  REVPAY: 'revpay-online',
  RAZER: 'razer',
  NETS: 'nets',
  TOUCHNGO: 'touchngo',
  WORLDPAY: 'worldpay',
  NOMU: 'nomu',
  SHOPBACK: 'shopback',
  DUITNOW: 'duitnow',
  CYBERSOURCE: 'cybersource',
  SHOPEE: 'shopee', // use shopee as acquirer
  BSN: 'bsn',
  PAYDEE: 'paydee',
  FOMOPAY: 'fomopay',
  ALLINPAY: 'allinpay',
}

export const PAYMENT_METHOD_LIST = {
  CARD: 'card',
  QR: 'qr',
  ONLINE: 'online',
  DCI: 'dci',
}

export const DEFAULT_OXYGEN7_ENTITY = 'OXYGEN7_BT';

export const OXYGEN7_ENTITIES = [
  { label: 'Oxygen7 BT', value: DEFAULT_OXYGEN7_ENTITY, sessionEntity: 'BT' },
  { label: 'Oxygen7 SG', value: 'SGP' },
  { label: 'Oxygen7 MY', value: 'MYS' },
  { label: 'Oxygen7 TH', value: 'THA' },
];

export const GRABPAY_HOSTNAME_MAPPING = {
  'grabpay-gw2': 'GrabPay V1',
  'grabpay-sg': 'GrabPay V2',
  'grabpay-v1': 'GrabPay-V1',
}

export const TRANSACTION_TYPE_LIST = ['SALE', 'VOID', 'REFUND', 'AUTHORIZATION'];
export const TRANSACTION_STATE_LIST = ['PENDING', 'SUCCESS', 'REJECTED', 'ERROR', 'CANCELLED', 'EXPIRED'];

export const PENDING_TYPES = {
  NO_FUND: {
    key: 'no_fund',
    label: 'No Fund',
    description: 'Transactions without Fund In'
  },
  NOT_SETTLED: {
    key: 'not_settled',
    label: 'Not Settled',
    description: 'Transactions without Settlement'
  },
  NO_PAYOUT: {
    key: 'no_payout',
    label: 'No Payout',
    description: 'Transactions without Fund Out'
  }
};

export const getPendingTypeKey = (label) => {
  const entry = Object.values(PENDING_TYPES).find(type => type.label === label);
  return entry ? entry.key : null;
};

export const getPendingTypeLabel = (key) => {
  const entry = Object.values(PENDING_TYPES).find(type => type.key === key);
  return entry ? entry.label : null;
};

export const PAYOUT_STATUS = {
  PAID: 'Paid',
  PENDING: 'Pending',
  PROCESSING: 'Processing'
};

export const TRANSACTION_STATES = {
  SUCCESS: 'SUCCESS',
  CAPTURED: 'CAPTURED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  ERROR: 'ERROR',
  CANCELLED: 'CANCELLED'
};

export const SOURCE = {
  GW2: 'gw2',
  GW3: 'gw3',
};

export const EXCEPTION_SOURCE = {
  INCOMING_EXCEPTION: 'Incoming Exception',
  PENDING_NO_FUND: 'Pending - No Fund',
};

export const EXCEPTION_ACTION_OPTIONS = [
  'Manual Fund Out',
  'No Fund Out',
  'No Fund In',
  'No Further Action',
];

export const EXCEPTION_ACTION_DEFAULT = EXCEPTION_ACTION_OPTIONS[0];

export const MIN_AMOUNT_DEFAULT = {
  'SGD': 0.5,
  'USD': 0.5,
  'EUR': 0.5,
  'MYR': 0.5,
  'JPY': 50,
  'THB': 10
};

export const DEFAULT_MIN_PAYOUT = [
  { currency: 'AUD', min_amount: 100 },
  { currency: 'CNY', min_amount: 500 },
  { currency: 'EUR', min_amount: 100 },
  { currency: 'IDR', min_amount: 1000000 },
  { currency: 'JPY', min_amount: 10000 },
  { currency: 'MMK', min_amount: 150 },
  { currency: 'MYR', min_amount: 300 },
  { currency: 'PHP', min_amount: 5000 },
  { currency: 'SGD', min_amount: 100 },
  { currency: 'THB', min_amount: 3000 },
  { currency: 'USD', min_amount: 100 },
];
